import type { ReactNode } from "react";
import { cn } from "@/lib/utils/cn";

export interface FieldProps {
  label?: string;
  hint?: string;
  error?: string;
  required?: boolean;
  htmlFor?: string;
  className?: string;
  children: ReactNode;
}

/** Shared label/hint/error chrome so every control lines up identically. */
export function Field({ label, hint, error, required, htmlFor, className, children }: FieldProps) {
  return (
    <div className={cn("flex flex-col gap-1.5", className)}>
      {label && (
        <label htmlFor={htmlFor} className="label-eyebrow">
          {label}
          {required && <span className="text-accent ml-1">*</span>}
        </label>
      )}
      {children}
      {error ? (
        <p className="text-xs text-danger">{error}</p>
      ) : hint ? (
        <p className="text-xs text-haze-400 leading-relaxed">{hint}</p>
      ) : null}
    </div>
  );
}
